module.exports = __webpack_public_path__ + "static/img/publicity3.8fc63ecd.jpg";